<template>
  <div>
    <van-row style="padding: 10px">
      <van-col :span="24">
        <span style="font-weight: bold; font-size: 17px">
          {{ detailsData.reserveDate }} {{ detailsData.reserveMealName }}
          <van-tag v-if="detailsData.orderType == 1" type="primary">
            治疗膳食
          </van-tag>
        </span>
      </van-col>
    </van-row>
    <van-row style="padding: 0 10px 10px 10px">
      <van-col :span="16">
        <span> 订单号: {{ detailsData.orderNo }} </span>
      </van-col>
      <van-col :span="8" align="right">
        <van-tag type="primary">{{ detailsData.statusName }}</van-tag>
      </van-col>
    </van-row>
    <van-row class="title" style="background: #f2f2f2; padding: 5px 10px">
      <van-col span="12">
        <span>菜品详情</span>
      </van-col>
    </van-row>
    <van-row>
      <van-row
        v-for="item in detailsData.businessCateringOrderDetailses"
        :key="item.id"
        style="width: 100%; padding: 15px 10px; border-bottom: 1px solid #ccc"
      >
        <van-col span="8">
          <span>{{ item.dishName }}</span>
        </van-col>
        <van-col span="8" align="center">
          <span>x {{ item.quantity }}</span>
        </van-col>
        <van-col span="8" align="right">
          <!-- <span>{{ item.dishName }}</span> -->
        </van-col>
      </van-row>
      <van-row style="width: 100%; padding: 10px">
        <van-col span="24" align="right">
          <span>合计金额：</span>
          <span style="font-weight: bold; font-size: 16px">
            ￥{{ detailsData.businessPayOrder.price }}
          </span>
        </van-col>
      </van-row>
      <van-row
        style="
          width: 100%;
          padding: 10px;
          border-top: 1px solid #000;
          border-bottom: 1px solid #000;
          margin-top: 10px;
        "
      >
        <van-col span="24" align="center">
          <van-icon name="phone" />
          <span>联系商家</span>
        </van-col>
      </van-row>
    </van-row>
    <van-row
      class="title"
      style="background: #f2f2f2; padding: 5px 10px; margin-top: 20px"
    >
      <van-col span="12">
        <span>配送信息</span>
      </van-col>
    </van-row>
    <van-row style="padding: 10px">
      <van-col span="24" style="padding: 5px 0">
        <span style="color: #999">配送地址：</span>
        <span>{{ detailsData.orgAddress }}</span>
      </van-col>
      <van-col span="24" style="padding: 5px 0">
        <span style="color: #999">交易单号：</span>
        <span>{{ detailsData.orderNo }}</span>
      </van-col>
      <van-col span="24" style="padding: 5px 0">
        <span style="color: #999">下单时间：</span>
        <span>{{
          $moment(detailsData.createTime).format("YYYY-MM-DD HH:mm:ss")
        }}</span>
      </van-col>
    </van-row>
  </div>
</template>
<script setup>
import { reactive, toRefs } from "vue";
import { orderDetails } from "@/api/orderingFood/orderingFood";
import { useRoute } from "vue-router";
const route = useRoute();
const state = reactive({
  detailsData: {
    businessPayOrder: {},
  },
});
const { detailsData } = toRefs(state);
const queryDetails = () => {
  orderDetails({ id: route.query.id }).then((v) => {
    const { data } = v;
    state.detailsData = data;
  });
};
queryDetails();
</script>
<style lang="scss" scoped>
.van-icon-phone {
  font-size: 20px;
  margin-right: 5px;
}
</style>
